import { Dispatch } from 'react';
import { SetActiveServiceAction, SetServiceAction, ToggleTransferAction } from './actions';
import { PassengerId, SegmentId, ServiceId } from '../../../../types';
import { GdsService_OrderAdditionalServiceGdsServiceVip_Fragment } from '@websky/graphql';
import { Service, StateBase } from './types';

export const useMethods = (dispatch: Dispatch<ToggleTransferAction | SetActiveServiceAction | SetServiceAction>) => {
	const setActiveService = (serviceId: ServiceId) => dispatch({ type: 'setActiveService', payload: serviceId });
	const toggleService = (
		passengerId: PassengerId,
		segmentId: SegmentId,
		service: GdsService_OrderAdditionalServiceGdsServiceVip_Fragment
	) => {
		dispatch({
			type: 'toggleTransfer',
			payload: {
				service,
				passengerId: passengerId,
				segmentId: segmentId
			}
		});
	};

	const setServiceState = (serviceState: StateBase<Service>['services']) => {
		dispatch({
			type: 'setService',
			payload: serviceState
		});
	};

	return {
		setActiveService,
		toggleService,
		setServiceState
	};
};
